/* eslint-disable import/no-anonymous-default-export */
import http from "./httpService";

import { default as apiConfing } from "../config.json";
import { AxiosResponse } from "axios";
import { MemberMediaProps } from "../typings/memberMedia";
import { VerifyPhotosProps } from "../pages/ProfileVerify/ProfilePhotoVerify";
import imageCompression from 'browser-image-compression';
const apiUrl = apiConfing.IS_DEVELOPMENT ? apiConfing.API_DEVELOPMENT : apiConfing.API_PRODUCTION;

const apiEndpoint = `${apiUrl}/Media`;


export async function getMemberDoubleMatchSticker(memberCodeStickerSender: number, isStickerSendToMe: boolean) {
  const url = `${apiEndpoint}/GetMemberDoubleMatchSticker?memberCodeStickerSender=${memberCodeStickerSender}&isStickerSendToMe=${isStickerSendToMe}`;
  return http.get(url);
}

export async function getStickers() {
  const url = `${apiEndpoint}/GetStickers`;
  return http.get(url);
}

export async function toggleProfilePicture(imageToSwitchToProfileImageId: number) {
  const url = `${apiEndpoint}/ToggleProfilePicture?imageToSwitchToProfileImageId=${imageToSwitchToProfileImageId}`;
  return http.get(url);
}


export async function switchToNextProfilePicture(currentProfileImageId: number, imageToSwitchToProfileImageId: number) {
  const url = `${apiEndpoint}/SwitchToNextProfilePicture?currentProfileImageId=${currentProfileImageId}&imageToSwitchToProfileImageId=${imageToSwitchToProfileImageId}`;
  return http.get(url);
}

export async function uploadProfileImage(memberCode: number, File: any, isProfilePicture: boolean): Promise<AxiosResponse<MemberMediaProps>> {

  const url = `${apiEndpoint}/UploadProfileImage?memberCode=${memberCode}&isProfilePicture=${isProfilePicture}`
  let formData;
  try {
    const options = {
      maxSizeMB: 0.2,
      maxWidthOrHeight: 1000,
      useWebWorker: true
    }
    const compressedFile = await imageCompression(File, options);
    formData = getFromData(compressedFile);
  } catch (error) {
    throw new Error("An error occurred while compressing the image");
  }
  return http.post(url, formData);
}

export function deleteMedia(memberCode: number, mediaId: number): Promise<AxiosResponse<boolean>> {
  const url = `${apiEndpoint}/DeleteMedia?memberCode=${memberCode}&mediaId=${mediaId}`
  return http.delete(url);

}

export function getMemberMedia(memberCode: number): Promise<AxiosResponse<MemberMediaProps[]>> {
  const url = `${apiEndpoint}/GetMemberMedia?memberCode=${memberCode}`
  return http.get(url);

}

export function getVerifyPhotos(memberCode: number): Promise<AxiosResponse<VerifyPhotosProps>> {
  const url = `${apiEndpoint}/GetVerifyPhotos?memberCode=${memberCode}`
  return http.get(url);
}

export function uploadVerificationImage(memberCode: number, imageId: number, File: any) {
  const formData = getFromData(File);
  const url = `${apiEndpoint}/UploadVerificationImage?memberCode=${memberCode}&imageId=${imageId}`
  return http.post(url, formData);
}



function getFromData(file: any) {
  const formData = new FormData();
  formData.append("formdata", file);
  return formData;
}


export default {
  uploadProfileImage,
  getMemberMedia,
  deleteMedia,
  getVerifyPhotos,
  uploadVerificationImage
};
